import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PdfCertificateStatus } from '../models/pdf-signer.models';

@Injectable({ providedIn: 'root' })
export class PdfCertificateApiService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl + '/pdf';

  getStatus(): Observable<PdfCertificateStatus> {
    return this.http.get<PdfCertificateStatus>(`${this.apiUrl}/certificate`);
  }

  upload(pfx: File, password: string): Observable<PdfCertificateStatus> {
    const formData = new FormData();
    formData.append('Pfx', pfx);
    formData.append('Password', password);

    return this.http.post<PdfCertificateStatus>(
      `${this.apiUrl}/certificate`,
      formData,
    );
  }

  delete(): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/certificate`);
  }
}
